/**
 * Created by ganlu on 02/12/2016.
 */
export default (getReproductionService) => {

    "ngInject";

    return (scope, elem, attrs) => {

        elem.on('copy cut', (e) => {
            if (!scope.copyAuthorized) {
                getReproductionService.get();
                e.preventDefault();
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/app/components/page/original/original-article/copy-check.directive.js